/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Title_2Inputs */

const en_wb_management_title_2 = /** @type {(inputs: Wb_Management_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already waiting on Monday.`)
};

const lv_wb_management_title_2 = /** @type {(inputs: Wb_Management_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmdienā jau gaida.`)
};

/**
* | output |
* | --- |
* | "Already waiting on Monday." |
*
* @param {Wb_Management_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_title_2 = /** @type {((inputs?: Wb_Management_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_title_2(inputs)
	return en_wb_management_title_2(inputs)
});